import React, { useState, useEffect, useRef } from "react";
import { Nav } from "react-bootstrap";
import "../../assets/styles/common/Sidebar.css";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"; // Added useLocation
import logo from "../../assets/images/FPC_Mini_Logo.png";
import userLogo from "../../assets/images/profile.jpg";
import LogoBig from "../../assets/images/FP-Logo_Color_logo.png";
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserData } from '../../redux/userActions';

import {
  FiSettings
} from "react-icons/fi";

import {
  FaTimes
} from "react-icons/fa";
import {
  LayoutDashboard,
  ChevronRight,
  ChevronLeft,
  Search,
  Handshake,
  UserRoundPlus
} from "lucide-react";

import Avatar from "../avatar/RandomAvatar";


const Sidebar = () => {
  const dispatch = useDispatch();
  const { userDetails, loading, error } = useSelector((state) => state.user);
  const roleMap = {
    0: 'SUPER ADMIN',
    1: 'ADMIN',
    2: 'AUDIT SUPERVISOR',
    3: 'AUDITOR',
    4: 'USER',
  };
  const [selectedRole, setSelectedRole] = useState("");
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!userDetails && token) {
      dispatch(fetchUserData());
    }
  }, [dispatch, userDetails]);

  useEffect(() => {
    if (userDetails?.role !== undefined) {
      const mapped = roleMap[userDetails.role];
      if (mapped) {
        setSelectedRole(mapped);
      }
    }
  }, [userDetails]);
  const userRole = selectedRole;
  const [expanded, setExpanded] = useState(false);
  const [activePopup, setActivePopup] = useState(null);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation(); // Added this line

  // Simple function to check if item is active - ADDED THIS FUNCTION
  const isActive = (item) => {
    if (item.type === 'link') {
      return item.link === location.pathname;
    }

    if (item.type === 'dropdown' && item.dropdownItems) {
      return item.dropdownItems.some(dropdownItem => dropdownItem.link === location.pathname);
    }

    return false;
  };

  // Top Menu Items (Navigation)
  const topMenuItems = {
    Dashboard: {
      name: "Dashboard",
      icon: <LayoutDashboard size={20} className="sidebar-icon" />,
      type: "link",
      link: "/dashboard",
      roles: 'USER,SUPER ADMIN,ADMIN',

    },
    dailyreportstatus: {
      name: "Daily Report Status",
      icon: <Handshake size={20} className="sidebar-icon" />,
      // icon: <Users size={20} className="sidebar-icon" />,
      type: "link",
      link: "/dsr",
      roles: 'USER,SUPER ADMIN,ADMIN',
    },
    Admin: {
      name: "Admin",
      // icon: <Users size={20} className="sidebar-icon" />,
      icon: <UserRoundPlus size={20} className="sidebar-icon" />,
      type: "link",
      link: "/admin",
      roles: 'SUPER ADMIN,ADMIN',

    },
  };

  // Bottom Menu Items (Profile/User related)
  const bottomMenuItems = {
    profile: {
      username: userDetails?.fullName || "Loading...",
      defaultEmail: userDetails?.email || "Loading...",
      role: selectedRole || "Loading...",
      userLogo: <Avatar id={userDetails?.smaID} />,
      type: "dropdown",
      items: {
        logout: {
          label: "Log out",
          icon: <i className="fa-solid fa-arrow-right-from-bracket ud-icon"></i>,
          link: '/'
        }
      },
      icons: {
        profile: <i className="fa-regular fa-user user-icon-ud"></i>,
      },
    },
  };

  // Logo Items
  const logoItems = {
    full: LogoBig,
    mini: logo,
  };

  const homePopupRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (homePopupRef.current && !homePopupRef.current.contains(event.target)) {
        setActivePopup(null);
      }
    };

    if (activePopup === "home") {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [activePopup]);

  // Close popups when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (activePopup && !event.target.closest('.sidebar-dropdown')) {
        setActivePopup(null);
      }
    }

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [activePopup]);
  const navigate = useNavigate();
  const handleLogout = () => {
    console.log("Logout clicked");
    navigate("/")
  }

  useEffect(() => {
    function handleClickOutside(event) {
      // If dropdown is open AND click is outside the menu/toggle → close it
      if (open && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  // Dynamic Menu Item Renderer
  const renderMenuItem = (itemKey, item, position = "top") => {
    const active = isActive(item); // Added this line

    switch (item.type) {
      case "dropdown":
        return (
          <Nav.Item className="sidebar-dropdown" key={itemKey}>
            <div onClick={(e) => e.stopPropagation()}>
              {expanded ? (
                // Expanded Sidebar - Dropdown
                <>
                  <div
                    className={`sidebar-dropdown-toggle ${active ? 'active ' + item.colorClass : ''}`} // Added className
                    onClick={() =>
                      setActivePopup((prev) => (prev === itemKey ? null : itemKey))
                    }
                  >
                    <div className="sidebar-dropdown-icon-title">
                      {item.icon}
                      <span className="sidebar-dropdown-title">
                        {item.name}
                      </span>
                    </div>
                    <span
                      className={`sidebar-dropdown-arrow ${activePopup === itemKey ? "open" : ""
                        }`}
                    >
                      <i className="fas fa-chevron-down sidebar-drop-icon"></i>
                    </span>
                  </div>

                  {/* Expanded dropdown items */}
                  {activePopup === itemKey && item.dropdownItems && (
                    <div className="sidebar-dropdown-menu">
                      {item.dropdownItems.map((dropdownItem, index) => {
                        const isDropdownActive = dropdownItem.link === location.pathname; // Added this line
                        return dropdownItem.link ? (
                          <Link
                            key={index}
                            to={dropdownItem.link}
                            className={`sidebar-dropdown-item ${isDropdownActive ? 'active ' + dropdownItem.colorClass : ''}`} // Added className
                            onClick={() => setActivePopup(null)}
                          >
                            {dropdownItem.label}
                          </Link>
                        ) : (
                          <div key={index} className="sidebar-dropdown-item">
                            {dropdownItem.label}
                          </div>
                        )
                      })}
                    </div>
                  )}
                </>
              ) : (
                // Collapsed Sidebar - Popup
                <>
                  <Nav.Link
                    className={`sidebar-link-collapsed ${active ? 'active ' + item.colorClass : ''}`}


                    onClick={() =>
                      setActivePopup((prev) => (prev === itemKey ? null : itemKey))
                    }
                  >
                    {item.icon}
                  </Nav.Link>

                  {/* Popup for collapsed sidebar */}
                  {activePopup === itemKey && item.dropdownItems && (
                    <div
                      className="sidebar-popup shadow"
                      onMouseLeave={() => setActivePopup(null)}
                    >
                      <ul className="list-unstyled mb-0">
                        {item.dropdownItems.map((dropdownItem, index) => {
                          const isDropdownActive = dropdownItem.link === location.pathname; // Added this line
                          return dropdownItem.link ? (
                            <Link
                              key={index}
                              to={dropdownItem.link}
                              onClick={() => setActivePopup(null)}
                            >
                              <li className={`sidebar-item ${isDropdownActive ? 'active ' + dropdownItem.colorClass : ''}`}> {/* Added className */}
                                {dropdownItem.label}
                              </li>
                            </Link>
                          ) : (
                            <li key={index} className="sidebar-item">
                              {dropdownItem.label}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </>
              )}
            </div>
          </Nav.Item>
        );

      case "search":
        return (
          <Nav.Item className="sidebar-dropdown" key={itemKey} onClick={(e) => e.stopPropagation()}>
            {expanded ? (
              // Expanded Sidebar - Search
              <>
                <div className="sidebar-dropdown-toggle" onClick={() => setActivePopup(itemKey)}>
                  <div className="sidebar-dropdown-icon-title">
                    {item.icon}
                    <span className="sidebar-dropdown-title">
                      {item.name}
                    </span>
                  </div>
                  <span className="sidebar-dropdown-arrow">
                    <i className="fas fa-chevron-right sidebar-drop-icon"></i>
                  </span>
                </div>

                {/* Search Popup */}
                {activePopup === itemKey && (
                  <div className="search-overlay" onClick={() => setActivePopup(null)}>
                    <div className="search-popup" onClick={(e) => e.stopPropagation()}>
                      <div className="popup-header">
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control popup-search-input"
                        />
                        <button className="close-btn" onClick={() => setActivePopup(null)}>
                          <FaTimes className="popup-icon" />
                        </button>
                      </div>
                      <div className="popup-body">
                        <h6 className="popup-title">Suggestions</h6>
                        <div className="row">
                          {item.popupContent.Suggestions.map(
                            (searchItem, index) => (
                              <div key={index} className="col-12 popup-item">
                                {searchItem.icon}
                                {searchItem.label}
                              </div>
                            )
                          )}
                        </div>
                        <h6 className="popup-title mt-3">Settings</h6>
                        <div className="row">
                          {item.popupContent.Settings.map(
                            (searchItem, index) => (
                              <div key={index} className="col-12 popup-item">
                                {searchItem.icon}
                                {searchItem.label}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              // Collapsed Sidebar - Search
              <>
                <Nav.Link onClick={() => setActivePopup(itemKey)}>
                  {item.icon}
                </Nav.Link>

                {activePopup === itemKey && (
                  <div className="search-overlay" onClick={() => setActivePopup(null)}>
                    <div className="search-popup" onClick={(e) => e.stopPropagation()}>
                      <div className="popup-header">
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control popup-search-input"
                        />
                        <button className="close-btn" onClick={() => setActivePopup(null)}>
                          <FaTimes className="popup-icon" />
                        </button>
                      </div>
                      <div className="popup-body">
                        <h6 className="popup-title">Suggestions</h6>
                        <div className="row">
                          {item.popupContent.Suggestions.map(
                            (searchItem, index) => (
                              <div key={index} className="col-12 popup-item ">
                                {searchItem.icon}
                                {searchItem.label}
                              </div>
                            )
                          )}
                        </div>
                        <h6 className="popup-title mt-3">Settings</h6>
                        <div className="row">
                          {item.popupContent.Settings.map(
                            (searchItem, index) => (
                              <div key={index} className="col-12 popup-item">
                                {searchItem.icon}
                                {searchItem.label}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </Nav.Item>
        );

      case "link":
        // Direct link item - no dropdown, just navigation
        return (
          <Nav.Item className="sidebar-item-link" key={itemKey}>
            {expanded ? (
              // Expanded Sidebar - Show icon and text]
              <Link
                to={item.link}
                className={`sidebar-link ${active ? 'active ' + item.colorClass : ''}`} // Added className
              >
                {/* <div className="sidebar-dropdown-toggle"> */}
                <div className={`sidebar-dropdown-toggle ${active ? 'active ' + (item.colorClass || '') : ''}`}>

                  <div className="sidebar-dropdown-icon-title">
                    {item.icon}
                    <span className="sidebar-dropdown-title">
                      {item.name}
                    </span>
                  </div>
                </div>
              </Link>
            ) : (
              // Collapsed Sidebar - Show only icon
              <Nav.Link
                as={Link}
                to={item.link}
                className={`sidebar-link-collapsed ${active ? 'active ' + item.colorClass : ''}`} // Added className
              >
                {item.icon}
              </Nav.Link>
            )}
          </Nav.Item>
        );

      default:
        return null;
    }
  };

  return (
    <div className={`sidebar ${expanded ? "expanded" : "collapsed"}`}>
      {/* Top Section - Navigation */}
      <Nav className="flex-column">
        {/* Logo */}
        <div className="sidebar-header d-flex align-items-center justify-content-between">
          <div className="logo-container d-flex align-items-center">
            <img
              src={expanded ? logoItems.full : logoItems.mini}
              alt="Logo"
              className={expanded ? "sidebar-logo-big" : "sidebar-logo"}
            />
          </div>
        </div>

        {Object.entries(topMenuItems)
          .filter(([key, item]) => {
            // Only include item if current user's role is allowed
            const allowedRoles = item.roles?.split(',').map(r => r.trim()) || [];
            return allowedRoles.includes(userRole);
          })
          .map(([key, item]) => renderMenuItem(key, item, "top"))
        }
      </Nav>

      {/* Bottom Section - Profile & Controls */}
      <div className="sidebar-footer">
        {/* Expand/Collapse Button */}
        <div
          className="sidebar-footer-icon"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? (
            <ChevronRight className="sidebar-icon" />
          ) : (
            <ChevronLeft className="sidebar-icon" />
          )}
        </div>

        <div className="ud-dropdown" ref={dropdownRef}>
          <div
            className={`ud-toggle ${expanded ? "ud-toggle-expanded" : ""}`}
            onClick={() => setOpen((prev) => !prev)}
          >
            <Avatar
              id={userDetails?.smaID}

            />
            {expanded && (
              <div className="sidebar-username-expand">
                <div className="sidebar-username">

                  {bottomMenuItems.profile.username}
                </div>
                <div className="sidebar-email">

                  {bottomMenuItems.profile.role}
                </div>
              </div>
            )}
          </div>

          {open && (
            <div
              className={`ud-menu ${expanded ? "ud-menu-expanded" : "ud-menu-collapsed"
                }`}
            >
              <div className="ud-email-dark">
                {bottomMenuItems.profile.userLogo}
                <div className="ud-email-info">
                  <div className="sidebar-username">
                    {bottomMenuItems.profile.username}
                  </div>
                  {/* <span className="ellipsis-text">
                    {bottomMenuItems.profile.defaultEmail}
                  </span> */}
                  <div className="sidebar-role">
                    {bottomMenuItems.profile.role}
                  </div>
                </div>

              </div>

              {/* <Link to={bottomMenuItems.profile.items.settings.link}>
                <div className="ud-item-dark">
                  {bottomMenuItems.profile.items.settings.icon}
                  <span>{bottomMenuItems.profile.items.settings.label}</span>
                </div>
              </Link> */}

              <hr className="custom-hr" />
              {/* <Link to={bottomMenuItems.profile.items.help.link}>
                <div className="ud-item-dark d-flex justify-content-between">
                 
                  {bottomMenuItems.profile.items.help.leftIcon}
                  {bottomMenuItems.profile.items.help.label}

                  <div>{bottomMenuItems.profile.items.help.rightIcon}</div>
                </div>
              </Link> */}

              <div className="ud-item-dark" onClick={handleLogout}>
                {bottomMenuItems.profile.items.logout.icon}
                <span>{bottomMenuItems.profile.items.logout.label}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;